module.exports = __webpack_public_path__ + "img/7.68966866.png";